
interface AlarmModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleRepeat: () => void;
  onStopButtonClick: () => void;
}

const AlarmModal = ({ isOpen, onClose, handleRepeat, onStopButtonClick }: AlarmModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-parchment-50 rounded-2xl shadow-xl w-full max-w-sm p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-ink-muted hover:text-ink text-2xl leading-none"
        >
          ×
        </button>

        <h2 className="text-xl font-bold text-ink mb-2">Continue Reading?</h2>
        <p className="text-ink-muted text-sm mb-6 text-center">Would you like to continue your reading session?</p>

        <div className="flex flex-col gap-3">
          <button
            onClick={onStopButtonClick}
            className="w-full py-3 rounded-lg bg-orange-500 hover:bg-orange-600 text-white font-semibold transition"
          >
            No — End Session
          </button>
          <button
            onClick={handleRepeat}
            className="w-full py-3 rounded-lg bg-leather hover:bg-leather-light text-parchment-100 font-semibold transition"
          >
            Yes — Repeat Timer
          </button>
          <button
            onClick={onClose}
            className="w-full py-3 rounded-lg bg-parchment-200 hover:bg-parchment-300 text-ink font-semibold transition"
          >
            Yes — Change Time
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlarmModal;
